export default __webpack_public_path__ + "static/media/iconDefaultRoomImage.181422ff.png";